export default __webpack_public_path__ + "static/media/hero-globe.9892e420.png";